// TODO: Подумать над вынесением в Vue-директиву и sizes атрибутом для картинок.
require('lazysizes');

// Добавение поддержки фоновых изображений блока подгружаемых из атрибута data-bg
document.addEventListener('lazybeforeunveil', function(e){
    let bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});